import { FC } from 'react';
import style from './DriveScoreStyle.module.css';

interface DriveScoreProps {
  score?: number;
}

export const DriveScore: FC<DriveScoreProps> = ({ score = 0 }) => {
  return (
    <div className={style.scoreWrapper}>
      <div className={style.driveScoreWrapper}>
        <span>
          <span className={style.driveScore}>{score}</span>
          <span className={style.driveScoreUnit}>点</span>
        </span>
      </div>
    </div>
  );
};
